import React, { useEffect, useState } from "react";
import { formatDate } from "../../helpers/utilities";
import { Divider } from "@mui/material";
import { useSelector } from "react-redux";
import { centralGetSignedUrlService } from "../../../_services";

const CentralLensDetailsAccordion = () => {
  const reportingData = useSelector(
    (state) => state.centralReportingData?.reportingData
  );
  const [lensData, setLensData] = useState([]);
  useEffect(() => {
    if (reportingData && reportingData?.data?.length) {
      const data = reportingData.data[0]?.lensDetails || [];
      setLensData(data);
    }
  }, [reportingData]);

  const handleSignedUrl = (url) => {
    centralGetSignedUrlService({ urls: [url] })
      .then((res) => {
        if (res?.status === "Success" && res.result.length > 0) {
          window.open(res.result[0]);
        }
      })
      .catch((err) => console.log("Signed URL error", err));
  };

  return (
    <div className="lensCardDetailsContainer">
      {lensData && lensData?.length > 0 ? (
        lensData.map((item, index) => (
          <div className="lensCardContainer">
            <div className="equipmentCountContainer">
              <span className="equipmentCountText">Item {index + 1}</span>
            </div>
            <Divider sx={{ margin: "5px 0 10px" }} />
            <div className="textReadOnlyRow">
              <span className="textReadOnlyLabel">Date</span>
              <span className="textReadOnlyValue">
                {formatDate(item.uploadedAt, "DD MMM, hh:mm A") || "--"}
              </span>
            </div>
            <div className="textReadOnlyRow">
              <span className="textReadOnlyLabel">Brand</span>
              <span className="textReadOnlyValue">{item.brand || "--"}</span>
            </div>
            <div className="textReadOnlyRow">
              <span className="textReadOnlyLabel">Model</span>
              <span className="textReadOnlyValue">{item.model || "--"}</span>
            </div>
            <div className="textReadOnlyRow">
              <span className="textReadOnlyLabel">Uploaded by</span>
              <span className="textReadOnlyValue">
                {item.uploadedByUsername || "--"}
              </span>
            </div>
            <div className="textReadOnlyRow">
              <span className="textReadOnlyLabel">Uploaded from</span>
              <span className="textReadOnlyValue">{item.source || "--"}</span>
            </div>
            <div className="textReadOnlyRow">
              <span className="textReadOnlyLabel">Proof</span>
              {item.proofURL ? (
                <div
                  className="defaultModalButton"
                  onClick={() => handleSignedUrl(item.proofURL)}
                >
                  View
                </div>
              ) : (
                <span className="textReadOnlyValue">NA</span>
              )}
            </div>
          </div>
        ))
      ) : (
        <span className="emptyEquipmentData">No Item available</span>
      )}
    </div>
  );
};

export default CentralLensDetailsAccordion;
